import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

const meterHeight = '8px';

export const SummaryWrapper = styled.div`
  display: flex;
  column-gap: 8px;
  justify-content: space-between;

  ${media.mediumDown`
    flex-direction: row;
  `};
`;

export const Distribution = styled.div`
  display: grid;
  grid-template-columns: 1fr 10fr 1fr;
  column-gap: ${layout.spacing.xSmall};
  row-gap: 2px;
  align-items: center;
  /* width: 100%; */
`;

export const Meter = styled.div`
  height: ${meterHeight};
  background: ${p => p.theme.bg.primary};
  box-shadow: 0 0 0 2px ${p => p.theme.lines.quaternary};
  border-radius: ${meterHeight};
`;

type IndicatorProps = {
  width: string;
};

export const Indicator = styled.div<IndicatorProps>`
  width: ${p => p.width};
  height: 100%;
  background: ${p => p.theme.lines.quaternary};
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
`;

export const MeterLabel = styled.span`
  white-space: nowrap;
  display: flex;
  align-items: center;
  column-gap: 2px;
  color: ${p => p.theme.text.secondary};

  &:nth-of-type(odd) {
    justify-content: flex-end;
  }
`;

export const Summary = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
`;

export const Score = styled.div``;

export const Value = styled.span`
  font-size: 36px;
`;

export const RatingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: ${layout.spacing.xxSmall};
  color: ${p => p.theme.text.tertiary};
  white-space: nowrap;
`;
